import { render, staticRenderFns } from "./calendarDay.vue?vue&type=template&id=24948daf&scoped=true&"
import script from "./calendarDay.vue?vue&type=script&lang=js&"
export * from "./calendarDay.vue?vue&type=script&lang=js&"
import style0 from "./calendarDay.vue?vue&type=style&index=0&id=24948daf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24948daf",
  null
  
)

export default component.exports